export { default } from './MoreDetails';
